import { Block } from "./block";

export class Comprobante{
	constructor(
	    	public id: String = "",
			public secuencial: String = "",
			public empresa_id: String = "",
			public sucursal_id: String = "",
	 		public caja_id: String = "",
			public tipo_comprobante_id: String = "",
			public usuario_id: String = null,
			public block: Block  = new Block(),
			public blocks = []
	){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/comprobante.ts